module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('isrs-i18n-dialog', _vm._b({}, 'isrs-i18n-dialog', {
    languages: _vm.languages,
    getText: _vm.getText,
    getDefault: _vm.getDefault,
    onSave: _vm.onSave,
    texts: _vm.texts
  }, false))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-dad05022"}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/EditTextsForm.vue
// module id = 956
// module chunks = 1